import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Mail, CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { Button } from "../components/ui/button";
import { API_URL } from "../utils/api";

export default function UnsubscribePage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token");
  const [status, setStatus] = useState("loading"); // loading | success | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!token) {
      setStatus("error");
      setMessage("Missing unsubscribe token.");
      return;
    }
    axios
      .get(`${API_URL}/newsletter/unsubscribe?token=${encodeURIComponent(token)}`)
      .then((res) => {
        setStatus("success");
        setMessage(res.data?.message || "You've been unsubscribed.");
      })
      .catch((err) => {
        setStatus("error");
        setMessage(err.response?.data?.detail || "Unable to unsubscribe. Token may be invalid.");
      });
  }, [token]);

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4 bg-gradient-to-br from-slate-950 via-slate-900 to-cyan-950/40"
      data-testid="unsubscribe-page"
    >
      <div className="max-w-md w-full bg-slate-800/60 backdrop-blur border border-slate-700 rounded-2xl p-10 text-center">
        <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-slate-700/50 flex items-center justify-center">
          {status === "loading" && <Loader2 className="w-8 h-8 text-cyan-400 animate-spin" />}
          {status === "success" && <CheckCircle2 className="w-8 h-8 text-emerald-400" />}
          {status === "error" && <XCircle className="w-8 h-8 text-rose-400" />}
        </div>
        <h1 className="text-2xl font-bold text-white mb-2">
          {status === "loading" && "Processing..."}
          {status === "success" && "Unsubscribed"}
          {status === "error" && "Couldn't unsubscribe"}
        </h1>
        <p className="text-slate-400 text-sm mb-6">{message}</p>
        {status !== "loading" && (
          <Button
            onClick={() => navigate("/")}
            className="bg-cyan-500 hover:bg-cyan-600 text-white"
            data-testid="unsubscribe-home-btn"
          >
            <Mail className="w-4 h-4 mr-2" /> Back to TaxSetu.ai
          </Button>
        )}
      </div>
    </div>
  );
}
